import Backbone from 'backbone';
import $ from 'jquery';

import i18n from '../i18n';

import { hashify } from '../utils/arrays';



// TODO: flashify
export { error, success, of, restore, clear, remove, $place, $input, };

function error(text) {
    return make( text, 'danger' );
}

function success(text) {
    return make( text, 'success' );
}

function make(text, level) {
    let message, field;

    if ('string' === typeof text)
        return cr( text, level );

    if (text instanceof Array)
        return [message, field] = text,
            cr( message, level, field );

    if ('object' === typeof text) 
        return { message, field } = text,
            cr( message, level, field );

    return cr( text, level );
}

function cr(text, level, field) {
    return {
        level, text, field,
        id: `message${Math.random().toFixed( 10 ).substr( 2 )}`,
        expirationTime: new Date().getTime() + 5000
    };
}

const messages = {};

function restore(view) {
    const now = new Date();

    // create $els if no
    of( view ).filter( message => !message.$el )
        .forEach( message => message.$el = $html( message ) );

    // remove expired with animation;
    // gather expired ids
    const expired = of( view ).filter( message => now > message.expirationTime ),
        expiredIds = hashify( expired, ({ id }) => [id] )
    expired.forEach( ({ $el }) => $el
        .addClass( 'animated fadeOut' )
        .one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', 
            () => $el.remove() ) );

    // leave out expired from list
    const nonExpired = of( view ).filter( message => now <= message.expirationTime );
    put( view, nonExpired );

    // gather ids of messages those are actual for this view;   
    // sweep out non-actual messages those are not expired
    // using map of actual ids;
    // do not use animation
    const actualIds = hashify( of( view ), ({ id }) => [id] );
    view.$el.find( '.__message' )
        .filter( (id, el) => !actualIds[el.id] )
        .filter( (id, el) => !expiredIds[el.id] )
        .remove();

    // append messages those not in the DOM
    of( view )
        .filter( ({ $el }) => !Backbone.$.contains( view.$el, $el ) )
        .forEach( message => append( view, message ) );

    // mark messages as old
    of( view ).forEach( message => message.rendered = true );
}

function clear(view) {
    put( view, [] );
    view.$el.find( '.__message' ).remove();
    return this;
}

function of(view) {
    return messages[view.cid] = messages[view.cid] || [];
}

function put(view, newMessages) {
    messages[view.cid] = newMessages;
}

function $input(view, { field }) {
    if (!field)
        return $();

    const $fieldItself = typeof field !== 'string' && view.$( field );
    if ($fieldItself.length)
        return $fieldItself;

    // regular field - search by (validation-name + name) attrs

    if (!(field instanceof Array)) {
        const $input = view.$( '[data-validation-name]' ).filter( (i, input) => 
            input.dataset.validationName.split( ',' ).some( name => name === field ) );
        
        return $input.length ? $input : view.$el.find( `[name="${encodeURIComponent( field )}"]` );
    }
    
    // custom field inside composite - search by name attr

    const result = field.map( (el, index) => index % 2 === 0
        // even -> translit or parent/leaf
        ? encodeURIComponent( el.replaceAll( '.', '[dot]' ) )
        // odd  -> index inside parent
        : `[${el}].` ); 

    return view.$el.find( `[name="${result.join( '' )}"]` );
}

function $place(view, { field }) {
    if (!field)
        return view.$el.find( '.messages' );

    const $inputField = $input( view, { field } );
    if (!$inputField.length)
        return view.$el.find( '.messages' );

    const $place = $inputField.closest( '.form-group' )
        .find( '.form-field--message-container' );
    if (!$place.length)
        return view.$el.find( '.messages' );

    return $place.eq( 0 );
}

function remove(instance, text) {
    const message = find( instance, text );
    if (!message)
        return;

    const index = of( instance ).indexOf( message )
    of( instance ).splice( index, 1 );
}

function find(instance, text) {
    return of( instance ).filter( message => 
        message.text === text )[0];
}

function stringify({ id, level, field }) {
    return !field ? `<p id="${id}" class="__message alert alert-${level}"></p>`
        : `<span class="form-field-message __message __message-${level}"></span>`;
}

function $html(message) {
    const $html = Backbone.$( stringify( message ) );
    i18n.then( i => $html.html( i( message.text ) ) );

    return $html;
}

// TODO: BETTER ANIMATION
// TODO: fadeOut ANIMATION FOR FIELD MESSAGES
function append(view, message) {
    const { rendered, $el, field } = message;
    // message is new? toggle animation on 
    // TODO: BLINKING!!!
    if (!rendered) $el.addClass( 'animated fadeIn' );
    // if message is already rendered but (somewhat) not in the DOM ->
    // then view has been rerendered
    // and we don't need animation at all
    // to prevent blinking effect
    if (rendered) $el.removeClass( 'animated fadeIn' );

    $el.prependTo( $place( view, message ) );
}


    



// WEBPACK FOOTER //
// ./src/js/ui/messages.js